import AgencyTransactionList from 'common/pages/agency-transactions/AgencyTransactionList.tsx'

export const AgencyTransactionListAdmin = (props: any) => <AgencyTransactionList {...props} admin />